import { render, staticRenderFns } from "./BaseLinkItemNav.vue?vue&type=template&id=3d2d86d1&scoped=true"
import script from "./BaseLinkItemNav.vue?vue&type=script&lang=js"
export * from "./BaseLinkItemNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2d86d1",
  null
  
)

export default component.exports